

























import Vue, { PropOptions } from 'vue'

import { COLUMN_TYPE } from '@locokit/lck-glossary'
import { ValidationProvider } from 'vee-validate'

import Checkbox from 'primevue/checkbox'

import {
  LckTableColumnValidation,
} from '@/services/lck-api/definitions'

import i18n from '@/plugins/i18n'

enum ValidationValue {
  BOOLEAN,
}

class ValidationRule {
  columnTypes: Set<COLUMN_TYPE> = new Set([]); // Restrict the rule to some column types. If empty, the rule can be applied to all column types
  id!: keyof LckTableColumnValidation; // Identifier of the validation rule (similar to the vee-validate rules)
  text!: string; // Rule label to display
  value!: ValidationValue[]; // Types of values that this rule can take
};

const validationRules: ValidationRule[] = [
  {
    columnTypes: new Set([]),
    id: 'required',
    text: i18n.t('pages.databaseSchema.validation.required').toString(),
    value: [ValidationValue.BOOLEAN],
  },
]

export default Vue.extend({
  name: 'ColumnValidation',
  components: {
    'p-checkbox': Vue.extend(Checkbox),
    'validation-provider': Vue.extend(ValidationProvider),
  },
  props: {
    columnValidation: {
      type: Object,
      default: () => ({}),
    } as PropOptions<LckTableColumnValidation>,
    columnType: {
      type: Number,
      default: null,
    } as PropOptions<COLUMN_TYPE | null>,
  },
  data (): {
    validationRules: ValidationRule[];
    } {
    return {
      validationRules,
    }
  },
  computed: {
    restrictedValidationRules () {
      // The current column can use generic rules (no specified column types)
      // and the rules related to its column type.
      if (this.columnType) {
        return validationRules.filter(
          ({ columnTypes }) =>
            columnTypes.size === 0 ||
            columnTypes.has(this.columnType as COLUMN_TYPE),
        )
      } else {
        return validationRules.filter(
          ({ columnTypes }) => columnTypes.size === 0,
        )
      }
    },
  },
  methods: {
    enableRule (rule: ValidationRule, enabled: boolean) {
      let defaultValue
      if (enabled) {
        switch (rule.value[0]) {
          case ValidationValue.BOOLEAN:
            defaultValue = true
            break
        }
        this.$set(this.columnValidation, rule.id, defaultValue)
      } else {
        this.$delete(this.columnValidation, rule.id)
      }
    },
  },
})
